import { useTranslation } from "react-i18next";
import Menu from "src/components/Menu";
import MenuItem from "src/components/Menu/Item";
import MenuItemText from "src/components/Menu/ItemText";
import { ReactComponent as MoreIcon } from "src/icons/more-vert.svg";

export default function MonitoringMenu({ isOpen, onClose, onDelete, onOpen }) {
  const { t } = useTranslation();
  return (
    <Menu
      popoverProps={{
        lazyBehavior: "unmount",
        isLazy: true
      }}
      elevationLevel={2}
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onClose}
      icon={MoreIcon}
    >
      <MenuItem onClick={onDelete}>
        <MenuItemText>{t("buttons.delete")}</MenuItemText>
      </MenuItem>
    </Menu>
  );
}
